import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import Common from "../based/Common";
import { NOTIFY } from "../based/Constants";
import { ConfirmDialog } from "../based/Dialog";
import CommonModal from "../based/Modal";
import { Notify } from "../based/Notify";
import { NumberToVietnamese } from "../based/NumberToVietnamese";
import InvoiceServices from "../based/services/InvoiceServices";
import { InvoiceManagementContext } from "./InvoiceManagementProvider";

function InvoiceManagementDetailModal({ originalInvoiceId, onSucceed, show, onClose }) {
    const { reasonId, setReasonId, showDetail, setShowDetail, showConfirmRelease, setShowConfirmRelease, showEditInvoice, setShowEditInvoice, showReasonModal, setShowReasonModal, setOriginalInvoiceId } = useContext(InvoiceManagementContext);
    const [busy, setBusy] = useState(false);
    const [model, setModel] = useState({});

    useEffect(() => {
        if (originalInvoiceId && show) {
            getData(originalInvoiceId);
        }
    }, [originalInvoiceId, show]);

    const getData = async (originalInvoiceId) => {
        setBusy(true);
        const [err, data] = await InvoiceServices.GetInfoHistoryById(originalInvoiceId);
        if (!err && data) {
            setModel(data);
        } else {
            setModel({});
        }
        setBusy(false);
    };

    const createDraft = async (originalInvoiceId) => {
        setBusy(true);
        const [err, data] = await InvoiceServices.CreateDraftInvoice(originalInvoiceId);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Tạo bản nháp thành công");
            getData(originalInvoiceId);
            onSucceed();
            onClose();
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Tạo bản nháp thất bại");
        }
        setBusy(false);
    };

    return (
        <CommonModal show={show} isBusy={busy} busyMsg={"Đang tải"} title={`Chi tiết hóa đơn`} onClose={() => onClose()} size="lg" hiddenFooter>
            <Wrapper>
                {model && model.id ? (
                    <div className="detail_invoice">
                        {model.invoiceOrderStatus && (
                            <div className="detail_invoice-header">
                                <span>{model.invoiceOrderStatus}</span>
                            </div>
                        )}
                        {model.taxCode ? (
                            <div className="detail_invoice-address">
                                <div className="detail_invoice-address-line">
                                    <div className="left-line">
                                        <span>Tên đơn vị:</span>
                                    </div>
                                    <div className="right-line">
                                        <span className="main">{model.companyName}</span>
                                    </div>
                                </div>
                                <div className="detail_invoice-address-line">
                                    <div className="left-line">
                                        <span>Mã số thuế:</span>
                                    </div>
                                    <div className="right-line">
                                        <span>{model.taxCode}</span>
                                    </div>
                                </div>
                                <div className="detail_invoice-address-line">
                                    <div className="left-line">
                                        <span>Địa chỉ:</span>
                                    </div>
                                    <div className="right-line">
                                        <span>{model.address}</span>
                                    </div>
                                </div>
                                <div className="detail_invoice-address-line">
                                    <div className="left-line">
                                        <span>Hình thức thanh toán:</span>
                                    </div>
                                    <div className="right-line">
                                        <span>{model.paymentMethodName}</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="detail_invoice-address">
                                <div className="detail_invoice-address-line">
                                    <div className="left-line">
                                        <span>Nội dung:</span>
                                    </div>
                                    <div className="right-line">
                                        <span className="main">KHÁCH KHÔNG LẤY HÓA ĐƠN</span>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="detail_invoice-table">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>
                                            <span>
                                                STT
                                                <sub>(No.)</sub>
                                            </span>
                                        </th>
                                        <th>
                                            <span>
                                                Tên hàng hóa, dịch vụ
                                                <sub>(Description)</sub>
                                            </span>
                                        </th>
                                        <th>
                                            <span>
                                                Đơn vị tính
                                                <sub>(Unit)</sub>
                                            </span>
                                        </th>
                                        <th>
                                            <span>
                                                Số lượng
                                                <sub>(Quantity)</sub>
                                            </span>
                                        </th>
                                        <th>
                                            <span>
                                                Đơn giá
                                                <sub>(Unit Price)</sub>
                                            </span>
                                        </th>
                                        <th>
                                            <span>
                                                Thành tiền
                                                <sub>(Amount)</sub>
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {model.invoiceInfoHistoryDetails &&
                                        model.invoiceInfoHistoryDetails.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.name}</td>
                                                    <td>Cái</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{Common.formatCurrency(item.unitPrice)}</td>
                                                    <td>{Common.formatCurrency(item.itemTotalAmountWithoutTax)}</td>
                                                </tr>
                                            );
                                        })}
                                    <tr>
                                        <td colSpan={5}>
                                            <span className="main justify-content-end">
                                                Cộng tiền hàng
                                                <sub> (Total Amount)</sub>
                                            </span>
                                        </td>
                                        <td>{Common.formatCurrency(model.totalAmountWithoutTax)}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <span className="main justify-content-center">
                                                Thuế suất GTGT
                                                <sub> (VAT Rate): 8%</sub>
                                            </span>
                                        </td>
                                        <td colSpan={3}>
                                            <span className="main justify-content-end">
                                                Tiền thuế GTGT
                                                <sub> (VAT Amount)</sub>
                                            </span>
                                        </td>
                                        <td>{Common.formatCurrency(model.taxAmount)}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={5}>
                                            <span className="main justify-content-end">
                                                TỔNG CỘNG TIỀN THANH TOÁN
                                                <sub> (Total payment)</sub>
                                            </span>
                                        </td>
                                        <td>
                                            <span className="main">{Common.formatCurrency(model.totalAmount)}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={6}>
                                            <span className="d-flex align-items-center">
                                                <span className="main">
                                                    Số tiền viết bằng chữ<sub> (Amount in words):</sub>
                                                </span>
                                                <span className="ml-1">{NumberToVietnamese(model.totalAmount)}</span>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <div>Không có dữ liệu</div>
                )}
                <div className="edit_invoice_button">
                    <div className="lst-button">
                        <button
                            className="btn btn-danger"
                            onClick={(e) => {
                                onClose();
                            }}
                        >
                            Đóng
                        </button>
                        {model.status != 1 && (
                            <>
                                <button
                                    className="btn btn-outline-custom"
                                    onClick={(e) => {
                                        if (!model.transactionUUID) {
                                            createDraft(originalInvoiceId);
                                        } else {
                                            ConfirmDialog("Xác nhận", "Hóa đơn đã được tạo bản nháp, bạn có muốn tạo thêm", () => {
                                                return new Promise((resolve, reject) => {
                                                    createDraft(originalInvoiceId)
                                                        .then(() => {
                                                            resolve({ title: "Thành công", msg: "Xóa thành công." });
                                                        })
                                                        .catch(() => {
                                                            reject({ title: "Thất bại", msg: "Vui lòng thử lại sau." });
                                                        });
                                                });
                                            });
                                        }
                                    }}
                                >
                                    Tạo bản nháp
                                </button>
                                <button
                                    className="btn btn-outline-custom"
                                    onClick={(e) => {
                                        setShowEditInvoice(true);
                                        setOriginalInvoiceId(originalInvoiceId);
                                        setShowDetail(false);
                                        setReasonId(0);
                                    }}
                                >
                                    Chỉnh sửa
                                </button>
                                <button
                                    className="btn btn-custom"
                                    onClick={(e) => {
                                        setShowConfirmRelease(true);
                                    }}
                                >
                                    Phát hành hóa đơn
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default InvoiceManagementDetailModal;

const Wrapper = styled.div`
    .lst-button {
        display: flex;
        margin-left: auto;
        gap: 16px;
    }

    .edit_invoice_button {
        display: flex;
    }

    .lst-button button {
        width: 160px;
    }

    .detail_invoice-header {
        background: #cdffdf;
        margin: -20px -20px 0 -20px;
        text-align: center;
        padding: 12px;
    }

    .detail_invoice-header span {
        color: #28b259;
        text-align: center;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .detail_invoice-address-line {
        display: flex;
        align-items: center;
        margin: 6px 0;
    }

    .detail_invoice-address-line .left-line {
        width: 150px;
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    span.main {
        font-weight: 700 !important;
        display: flex;
        align-items: center;
    }

    .right-line span {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .detail_invoice-bank-info {
        display: flex;
        align-items: center;
        gap: 150px;
    }

    .detail_invoice-bank-info-item {
        display: flex;
        align-items: center;
    }

    .bank-info-label {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .bank-info-value {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 20px;
    }

    .detail_invoice-table {
        margin: 16px 0;
    }

    table.table.table-bordered thead {
        border-radius: 2px 2px 0 0;
        border: 1px solid #a0a0a0;
        background: #ededed;
        height: 56px;
    }

    thead tr th span {
        display: flex;
        flex-direction: column;
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    thead tr th {
        vertical-align: middle !important;
    }

    thead sub {
        color: #848484;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    tbody sub {
        color: #848484;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: contents;
        margin-left: 6px !important;
    }

    tbody tr td span.main {
        display: flex !important;
        align-items: center;
        color: #444;
        text-align: center;
        font-family: Roboto;
        font-size: 14px !important;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }
`;
